/**
 * Export all constructs under the models namespace.
 */

export * from "@courses-models/license/src/ts/config/api";
